import { StandaloneCheckboxProps } from '@/components/element/Checkbox';
import { StandaloneComponent } from '@/types/component';
import mergeProps from 'lib/utils/mergeProps';
import { standaloneComponent } from 'modules/dynamic-components';

const Checkbox = standaloneComponent<StandaloneCheckboxProps>('ElementCheckbox');

interface ToggleProps extends StandaloneCheckboxProps {
  onChange: (value: any) => void;
  checked?: boolean;
  defaultChecked?: boolean;
}

export const Toggle: StandaloneComponent<ToggleProps> = ({ onChange, checked, defaultChecked, ...props }) => {
  return (
    <Checkbox
      {...mergeProps(
        {
          options: {
            $input: {
              onChange: ({ target: { checked } }: any) => onChange(checked),
              checked,
              defaultChecked,
            },
          },
        },
        props
      )}
    />
  );
};
